import { render } from "./IconRecipientsComplete.vue?vue&type=template&id=361914da"
import script from "./IconRecipientsComplete.vue?vue&type=script&lang=js"
export * from "./IconRecipientsComplete.vue?vue&type=script&lang=js"
script.render = render

export default script